module.exports = __webpack_public_path__ + "img/banner.83b9ac90.png";